import { formatDate } from "../../../../components/common/Converter";

export function GenerateApplicantCSV(object) {
  // Define the CSV header row
  let csvContent = `Name,Position Title,Cellphone Number,Birth Date,Gender,Job Opportunities,Referral By,Email, Last School Attended - Elementary,Last School Attended - High School,Year Graduated - High School,Last School Attended - Vocational,Last School Attended - Bachelor Degree,Bachelor Degree Course,Last School Attended - Masters Degree,Masters Degree Course,Last School Attended - Doctorate Degree,Doctorate Degree,Eligibility,Name of Immediate Supervisor,Position of Immediate Supervisor,Email Address of Immediate Supervisor,Office Name and Address of Immediate Supervisor,Name of Colleague 1,Position Title of Colleague 1,Division of Colleague 1,Contact Number of Colleague 1,Office name and Address Colleague 1,Name of Colleague 2,Position Title of Colleague 2,Division of Colleague 2,Contact Number of Colleague,Office name and Address Colleague 2,Name of Colleague 3,Position Title of Colleague 3,Division of Colleague 3,Contact Number of Colleague 3,Office name and Address Colleague 3,Name of subordinate,Position Title of Subordinate,Email Address of Subordinate,Contact Number of Subordinate,Office Name and Address of Subordinate,\n`;

  // Append the data from the object to the CSV in a single row, with values wrapped in double quotes
  const applicantName = `${object?.Firstname} ${object?.Middlename} ${object?.surname}`;
  csvContent +=
    [
      `"${applicantName || ""}"`,
      `"${object?.positionTitle?.position_title || ""}"`,
      `"${object?.mobile || ""}"`,
      `"${formatDate(object?.birthDate) || ""}"`,
      `"${object?.sex || ""}"`,
      `"${object?.jobOpportunities || ""}"`,
      `"${object?.referralBy || ""}"`,
      `"${object?.email || ""}"`,
      `"${object?.elementarySchool || ""}"`,
      `"${object?.highSchool || ""}"`,
      `"${object?.vocationalCourse || ""}"`,
      `"${object?.graduatedVocational || ""}"`,
      `"${object?.bachelorDegreeSchool || ""}"`,
      `"${object?.bachelorDegreeCourse || ""}"`,
      `"${object?.masterDegreeSchool || ""}"`,
      `"${object?.masterDegreeCourse || ""}"`,
      `"${object?.doctorateDegreeSchool || ""}"`,
      `"${object?.doctorateDegree || ""}"`,
      `"${object?.eligibility || ""}"`,
      `"${object?.nameImmediateSupervisor || ""}"`,
      `"${object?.positionImmediateSupervisor || ""}"`,
      `"${object?.emailImmediateSupervisor || ""}"`,
      `"${object?.officeImmediateSupervisor || ""}"`,
      `"${object?.nameColleaguePeer1 || ""}"`,
      `"${object?.positionColleaguePeer1 || ""}"`,
      `"${object?.divisionColleaguePeer1 || ""}"`,
      `"${object?.contactColleaguePeer1 || ""}"`,
      `"${object?.addressColleaguePeer1 || ""}"`,
      `"${object?.nameColleaguePeer2 || ""}"`,
      `"${object?.positionColleaguePeer2 || ""}"`,
      `"${object?.divisionColleaguePeer2 || ""}"`,
      `"${object?.contactColleaguePeer2 || ""}"`,
      `"${object?.addressColleaguePeer2 || ""}"`,
      `"${object?.nameColleaguePeer3 || ""}"`,
      `"${object?.positionColleaguePeer3 || ""}"`,
      `"${object?.divisionColleaguePeer3 || ""}"`,
      `"${object?.contactColleaguePeer3 || ""}"`,
      `"${object?.addressColleaguePeer3 || ""}"`,
      `"${object?.nameSubordinate || ""}"`,
      `"${object?.positionSubordinate || ""}"`,
      `"${object?.emailSubordinate || ""}"`,
      `"${object?.contactSubordinate || ""}"`,
      `"${object?.officeSubordinate || ""}"`,
    ].join(",") + "\n"; // Join data with commas and add a newline at the end of the row

  // Create a blob from CSV content
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  // Create a link element and trigger download
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `JobApplicant-${new Date().toISOString().split("T")[0]}.csv`
  );
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
